// Tool id → interactive component. Only published tools are mapped here.
import { ToolP03, ToolP04, ToolP09 } from "./calcPricing";
import { ToolD01, ToolD02, ToolD03, ToolD05 } from "./calcDigital";
import { ToolS01, ToolM13 } from "./calcSalesIntel";
import { ToolG01, ToolG02 } from "./assessGrowth";
import { ToolP01 } from "./profitLeak";
import { ToolG03, ToolG04, ToolG12 } from "./growthCalc";
import { ToolP02, ToolP08, ToolP12, ToolP13 } from "./pricingCalc2";
import { ToolP10, ToolP11, ToolP14 } from "./dataTables";
import { ToolG05, ToolG06, ToolG07, ToolG08, ToolG09, ToolG10 } from "./growthPlanners";
import { ToolG11, ToolP05, ToolP06, ToolP07 } from "./deckAndAssess";
import { ToolM01, ToolM03, ToolM11, ToolM12 } from "./marketCalc";
import { ToolM02, ToolM04, ToolM05, ToolM06, ToolM07, ToolM09, ToolM10, ToolM08 } from "./intelKits";
import { ToolC04, ToolC06, ToolC07, ToolC09, ToolC13, ToolC14 } from "./channelCalc";
import { ToolC01, ToolC02, ToolC03, ToolC05, ToolC08, ToolC10, ToolC11, ToolC12 } from "./channelPlanners";
import { ToolS02, ToolS05, ToolS12, ToolB09, ToolB10, ToolB13 } from "./salesCalc";
import { ToolS03, ToolS04, ToolS06, ToolS07, ToolS08, ToolS09, ToolS10, ToolS11, ToolS13, ToolS14 } from "./salesKits";
import { ToolB01, ToolB02, ToolB03, ToolB04, ToolB05, ToolB06, ToolB07, ToolB08, ToolB11, ToolB12 } from "./brandTools";
import { ToolD04, ToolD06, ToolD07, ToolD12 } from "./digitalCalc";
import { ToolD08, ToolD09, ToolD16 } from "./digitalAssess";
import { ToolD10, ToolD11, ToolD13, ToolD14, ToolD15 } from "./digitalKits";
import { ToolI01, ToolI03, ToolI05, ToolI07 } from "./industryCalc";
import { ToolI02, ToolI04, ToolI06, ToolI08 } from "./industryPlanners";

export const TOOL_COMPONENTS = {
  P01: ToolP01, P02: ToolP02, P03: ToolP03, P04: ToolP04, P05: ToolP05,
  P06: ToolP06, P07: ToolP07, P08: ToolP08, P09: ToolP09, P10: ToolP10,
  P11: ToolP11, P12: ToolP12, P13: ToolP13, P14: ToolP14,
  G01: ToolG01, G02: ToolG02, G03: ToolG03, G04: ToolG04, G05: ToolG05,
  G06: ToolG06, G07: ToolG07, G08: ToolG08, G09: ToolG09, G10: ToolG10,
  G11: ToolG11, G12: ToolG12,
  D01: ToolD01, D02: ToolD02, D03: ToolD03, D04: ToolD04, D05: ToolD05,
  D06: ToolD06, D07: ToolD07, D08: ToolD08, D09: ToolD09, D10: ToolD10,
  D11: ToolD11, D12: ToolD12, D13: ToolD13, D14: ToolD14, D15: ToolD15,
  D16: ToolD16,
  I01: ToolI01, I02: ToolI02, I03: ToolI03, I04: ToolI04,
  I05: ToolI05, I06: ToolI06, I07: ToolI07, I08: ToolI08,
  S01: ToolS01, S02: ToolS02, S03: ToolS03, S04: ToolS04, S05: ToolS05,
  S06: ToolS06, S07: ToolS07, S08: ToolS08, S09: ToolS09, S10: ToolS10,
  S11: ToolS11, S12: ToolS12, S13: ToolS13, S14: ToolS14,
  B01: ToolB01, B02: ToolB02, B03: ToolB03, B04: ToolB04, B05: ToolB05,
  B06: ToolB06, B07: ToolB07, B08: ToolB08, B09: ToolB09, B10: ToolB10,
  B11: ToolB11, B12: ToolB12, B13: ToolB13,
  M01: ToolM01, M02: ToolM02, M03: ToolM03, M04: ToolM04, M05: ToolM05,
  M06: ToolM06, M07: ToolM07, M08: ToolM08, M09: ToolM09, M10: ToolM10, M11: ToolM11,
  M12: ToolM12, M13: ToolM13,
  C01: ToolC01, C02: ToolC02, C03: ToolC03, C04: ToolC04, C05: ToolC05,
  C06: ToolC06, C07: ToolC07, C08: ToolC08, C09: ToolC09, C10: ToolC10,
  C11: ToolC11, C12: ToolC12, C13: ToolC13, C14: ToolC14,
};
